<template>
    <div class="custom-file">
        <input type="file"
               class="custom-file-input"
               :id="inputFieldId"
               :disabled="data.disabled"
               :multiple="data.multiple"
               v-on="listeners">
        <label class="custom-file-label" :for="inputFieldId">
            {{ fileLabel }}
        </label>
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name    : "FileUpload",
    mixins  : [InputMixin],
    computed: {
        fileLabel() {
            if (this.value && this.fieldValue && this.fieldValue === this.value) {
                if (this.data.multiple && this.value.length > 0) {
                    return `${this.value.length} file(s) selected`;
                }
                return this.value?.name || this.data.label;
            }
            return this.data.label;
        }
    }
}
</script>
